import React, {createContext, ReactNode, useCallback, useContext, useMemo, useState} from 'react';

interface TopBarActionsContextType {
  actions: ReactNode | null;
  setActions: (actions: ReactNode | null) => void;
}

const TopBarActionsContext = createContext<TopBarActionsContextType | undefined>(undefined);

export function TopBarActionsProvider({ children }: { children: ReactNode }) {
  const [actions, setActionsState] = useState<ReactNode | null>(null);

  const setActions = useCallback((newActions: ReactNode | null) => {
    setActionsState(newActions);
  }, []);

  const value = useMemo(() => ({ actions, setActions }), [actions, setActions]);

  return (
    <TopBarActionsContext.Provider value={value}>
      {children}
    </TopBarActionsContext.Provider>
  );
}

export function useTopBarActions() {
  const context = useContext(TopBarActionsContext);
  if (context === undefined) {
    throw new Error('useTopBarActions must be used within a TopBarActionsProvider');
  }
  return context;
}
